
import { BCMSDefaultModel, BCMSRecord, DisabledPrompt, Link, StateManager, useBCMSContext, useParams, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from "components/ui/UIButton";
import Classes, { Transaction, TransactionDispute } from 'model';
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function DisputeContactView
 * @return {React.Component}
 * @exported true
 * @description This is the view shown if the “No, I don’t recognize the transaction.” option is selected on the first step of the workflow. 
 * @example
 * <DisputeContactView />
 */
export default function DisputeContactView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();
  const params = useParams();
  const cardID = params.cardID ?? "0";
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    disputeTransaction: evt => {
      data.dispute.id = TransactionDispute.nextID();

      BCMSRecord.batch([
        TransactionDispute.create({ ...data.dispute.record }),
        Transaction.update({ ...data.dispute.transaction.record, transactionDispute: data.dispute })
      ], bcmsContext, Classes);

      navigate(`/home/viewalltransactions/${ cardID }/disputeTransactionWorkflow`);
    }
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, disputeTransaction } = useStateManager();
  const dispute = data.dispute ?? {};

  return (
    <div className="dispute-contact-view text-center">
      <div className="framed-icon-container">
        <SVGAsset id="CheckmarkBadgeIcon" />
      </div>
      <p className="contact-message"><DisabledPrompt><Link>Contact Us</Link></DisabledPrompt> immediately to report the fraudulent activity and get assistance on obtaining a new card. </p>
      <UIPrimaryButton text="OK" onClick={ disputeTransaction } />
    </div>
  );
}